/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | deutsche_post_postkarte | Postkarte|
 * | deutsche_post_standardbrief | Standardbrief|
 * | deutsche_post_kompaktbrief | Kompaktbrief|
 * | deutsche_post_grossbrief | Grossbrief|
 * | deutsche_post_maxibrief | Maxibrief|
 * | deutsche_post_maxibrief_plus | Maxibrief Plus|
 * | deutsche_post_warenpost_international_xs | Warenpost International XS|
 * | deutsche_post_warenpost_international_s | Warenpost International S|
 * | deutsche_post_warenpost_international_m | Warenpost International M|
 * | deutsche_post_warenpost_international_l | Warenpost International L|
 */
export const ServiceLevelDeutschePostEnum = {
  DeutschePostPostkarte: "deutsche_post_postkarte",
  DeutschePostStandardbrief: "deutsche_post_standardbrief",
  DeutschePostKompaktbrief: "deutsche_post_kompaktbrief",
  DeutschePostGrossbrief: "deutsche_post_grossbrief",
  DeutschePostMaxibrief: "deutsche_post_maxibrief",
  DeutschePostMaxibriefPlus: "deutsche_post_maxibrief_plus",
  DeutschePostWarenpostInternationalXs:
    "deutsche_post_warenpost_international_xs",
  DeutschePostWarenpostInternationalS:
    "deutsche_post_warenpost_international_s",
  DeutschePostWarenpostInternationalM:
    "deutsche_post_warenpost_international_m",
  DeutschePostWarenpostInternationalL:
    "deutsche_post_warenpost_international_l",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | deutsche_post_postkarte | Postkarte|
 * | deutsche_post_standardbrief | Standardbrief|
 * | deutsche_post_kompaktbrief | Kompaktbrief|
 * | deutsche_post_grossbrief | Grossbrief|
 * | deutsche_post_maxibrief | Maxibrief|
 * | deutsche_post_maxibrief_plus | Maxibrief Plus|
 * | deutsche_post_warenpost_international_xs | Warenpost International XS|
 * | deutsche_post_warenpost_international_s | Warenpost International S|
 * | deutsche_post_warenpost_international_m | Warenpost International M|
 * | deutsche_post_warenpost_international_l | Warenpost International L|
 */
export type ServiceLevelDeutschePostEnum = ClosedEnum<
  typeof ServiceLevelDeutschePostEnum
>;

/** @internal */
export const ServiceLevelDeutschePostEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelDeutschePostEnum
> = z.nativeEnum(ServiceLevelDeutschePostEnum);

/** @internal */
export const ServiceLevelDeutschePostEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelDeutschePostEnum
> = ServiceLevelDeutschePostEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelDeutschePostEnum$ {
  /** @deprecated use `ServiceLevelDeutschePostEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelDeutschePostEnum$inboundSchema;
  /** @deprecated use `ServiceLevelDeutschePostEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelDeutschePostEnum$outboundSchema;
}
